import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import App from './App';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Fragment>
        <Router>
            <Routes>
                <Route path="/*" element={<App/>} />
            </Routes>
        </Router>
    </React.Fragment>
);